import { useEffect, RefObject } from 'react';

type AnyEvent = MouseEvent | TouchEvent;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useOnHoverOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: AnyEvent) => void
) {
  useEffect(
    () => {
      const listener = (event: AnyEvent) => {
        // Do nothing if Hovering ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target as Node)) {
          return;
        }

        handler(event);
      };

      document.addEventListener('mouseover', listener);

      return () => {
        document.removeEventListener('mouseover', listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}

export default useOnHoverOutside;
